import React from "react";

const TopCoinProtectionPolicyContent = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">TopCoin UK Ltd - TopCoin Protection & Platform Security Policy</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Effective Date: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Company Registration No.: 16483297 | info@topcoinuk.com</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Issued by: TopCoin UK Ltd</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. Purpose of This Policy</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  This policy explains how TopCoin UK Ltd ("TopCoin UK", "we", "us" or "our") protects customer accounts, TopCoin records, Captain TC Rewards information and other records held within the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK operates an <strong>advertising, promotional, customer loyalty and rewards platform</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The purpose of this policy is to explain the operational, technical and account-security measures used to protect the integrity of the TopCoin UK system.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. Important - TopCoin UK Does Not Hold Customer Money</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK does <strong>not operate customer cash wallets</strong> as part of the TopCoin loyalty system.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  <strong>Customers are not required to provide bank account details in order to hold TopCoin or participate in the TopCoin and Captain TC loyalty programmes.</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The TopCoin Wallet, Captain TC Rewards Wallet and Captain TC Gold Wallet are loyalty and rewards programme facilities used to record or display programme activity.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  They are <strong>not bank accounts, savings accounts or customer cash accounts</strong>.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. What TopCoin Is</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin is a <strong>digital loyalty and reward unit</strong> used within the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Qualifying TopCoin may be awarded through eligible purchases, transactions, promotions or other qualifying activities identified by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin itself is not cash; is not a cryptocurrency; is not a bank deposit; is not a savings product; is not an investment; does not pay interest or dividends; and has no standalone monetary or exchange value outside the TopCoin UK rewards system.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin is used to record qualifying customer participation and progress within the TopCoin UK loyalty and rewards ecosystem.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. TopCoin Wallet Protection</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer's qualifying original TopCoin is recorded within their <strong>TopCoin Wallet</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK aims to maintain accurate electronic records of TopCoin credited to each eligible customer account.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin records should only be created, adjusted, corrected or reversed through authorised system or administrative processes.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where a legitimate technical or administrative error is identified, TopCoin UK may investigate and correct the affected TopCoin record using reasonably verifiable information.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. Captain TC Rewards Wallet Protection</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers with a valid and active Captain TC Rewards Card may use their <strong>Captain TC Rewards Wallet</strong> to view their active Captain TC Rewards Card, Captain TC Rewards TopCoin, progress towards the next applicable reward stage, qualifying Captain TC rewards earned and other applicable programme information.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Captain TC Rewards Wallet is a <strong>loyalty and rewards programme record and display facility</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  It does not hold customer money and does not require a customer bank account in order to record Captain TC Rewards TopCoin or programme progress.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. Captain TC Gold Wallet Protection</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The <strong>Captain TC Gold Wallet</strong> is used to record qualifying Captain TC Gold Cards registered by an eligible customer and to display applicable Gold Card progress.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Each qualifying unique Captain TC Gold Card or serial number may only be registered in accordance with the Captain TC Rewards Programme Terms & Conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The Captain TC Gold Wallet does not hold customer money and is not a bank or payment account.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. The Three TopCoin UK Wallet Functions</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  For clarity, the current TopCoin UK and Captain TC platform uses three distinct wallet functions:
                </p>
                <ul className="info_description text-dark opacity-50 mb-2">
                  <li><strong>TopCoin Wallet</strong> - Records the customer's qualifying original TopCoin.</li>
                  <li><strong>Captain TC Rewards Wallet</strong> - Displays the customer's active Captain TC Rewards Card, Captain TC Rewards TopCoin progress and applicable Captain TC rewards earned.</li>
                  <li><strong>Captain TC Gold Wallet</strong> - Records qualifying Captain TC Gold Cards and applicable Gold Card progress.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  None of these three wallets is intended to operate as a conventional customer bank account or cash wallet.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. Protection of Customer Records</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK aims to protect customer programme records against unauthorised alteration, loss, misuse and inappropriate access.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Depending on the systems in operation, TopCoin UK may use measures including secure hosting and infrastructure; account authentication; access controls; appropriate encryption; secure data storage; backup procedures; fraud-prevention controls; monitoring; restricted administrative access; system maintenance and security updates; and business-continuity procedures.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Security arrangements may develop as the TopCoin UK platform develops.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. Technical Errors</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  If a customer believes their TopCoin or Captain TC programme information is incorrect because of a technical or administrative error, they should contact TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may investigate the matter using available platform and transaction records.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where an error within the TopCoin UK system is reasonably verified, TopCoin UK may correct the relevant record.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Any correction will remain subject to the applicable programme terms and available supporting information.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Backups and System Recovery</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may maintain backup and recovery procedures designed to protect important customer and programme records.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  If a technical failure or system interruption occurs, TopCoin UK will take reasonable steps to recover affected information using available verified records and backup systems.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK does not guarantee that every technical incident can be prevented or that every service will always remain uninterrupted.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Fraud Prevention</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may monitor programme activity for suspected fraud, misuse or manipulation.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  This may include suspected artificial generation of TopCoin; false or manipulated qualifying transactions; duplicate transactions; multiple accounts created to circumvent programme rules; unauthorised Captain TC Rewards Card activity; duplicate or unauthorised Captain TC Gold Card registrations; manipulation of reward eligibility; account compromise; or other material misuse of the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may investigate, restrict or suspend relevant activity where reasonably necessary and permitted by the applicable terms and law.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. Legitimate Adjustments to TopCoin Records</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Protecting a customer's TopCoin record does not mean that a TopCoin balance can never change.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin or Captain TC Rewards TopCoin may be corrected or reversed where appropriate, including where a qualifying purchase is cancelled; a purchase is refunded; a transaction is reversed; TopCoin was credited incorrectly; a duplicate credit occurred; fraud or misuse is established; or the original transaction did not satisfy the applicable qualifying conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Any adjustment should be made in accordance with the applicable programme terms.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">13. Customer Account Security</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers also have an important role in protecting their TopCoin UK accounts.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers should keep their login credentials secure and should not intentionally provide unauthorised persons with access to their accounts.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers should also protect Captain TC card numbers, unique serial numbers and other security information associated with their account.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Suspected unauthorised account activity should be reported to TopCoin UK as soon as reasonably practicable.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">14. Captain TC Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC rewards are provided subject to the applicable <strong>Captain TC Rewards Programme Terms & Conditions</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC rewards may include gift cards, eGift cards, vouchers, products, promotional benefits or other rewards made available by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  <strong>TopCoin UK does not operate a customer cash-reward wallet as part of the Captain TC Rewards Programme.</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Third-party rewards may be subject to the applicable provider's terms, availability, restrictions and expiry conditions.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">15. How Captain TC Rewards Are Funded</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards are funded or provided by <strong>TopCoin UK Ltd as part of its advertising, promotional, loyalty and customer-acquisition activities</strong>, except where a particular promotion expressly states otherwise.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participating companies, shops and retailers may separately pay TopCoin UK for advertising, promotional, loyalty or other agreed commercial services.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers are not making deposits into TopCoin UK in order to fund Captain TC rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">16. No Bank Details Required for Loyalty Wallets</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK does not require customers to provide bank account details simply to hold qualifying TopCoin; use the TopCoin Wallet; hold an active Captain TC Rewards Card; receive Captain TC Rewards TopCoin; use the Captain TC Rewards Wallet; register qualifying Captain TC Gold Cards; or use the Captain TC Gold Wallet.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  If TopCoin UK introduces a separate service in the future that requires payment or payment-processing information, the applicable information and terms will be provided separately.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">17. No Deposit or Investment Protection Representation</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Because TopCoin is not represented as customer money or a bank deposit, this policy should not be interpreted as a bank-deposit protection scheme.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The word <strong>"protection"</strong> in this policy refers to the measures TopCoin UK uses to protect its platform, customer accounts, programme records, TopCoin records and reward information.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  It does not mean that TopCoin is an insured financial deposit or investment.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">18. No Guaranteed Financial Return</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participation in TopCoin UK or Captain TC does not constitute an investment by the customer.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK does not promise customers interest, dividends, investment growth, investment profits or guaranteed financial returns.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Eligibility for loyalty rewards is determined by the applicable programme rules and qualifying activity.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">19. Personal Information and Data Protection</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK processes personal information in accordance with the <strong>TopCoin UK Privacy Policy</strong> and applicable data-protection requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Measures used to protect personal information are separate from the rules governing TopCoin and reward eligibility.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should refer to the TopCoin UK Privacy Policy for further information concerning personal-data processing and their applicable rights.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">20. Platform Availability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK aims to maintain reliable access to its platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  However, no online platform can guarantee uninterrupted or error-free operation.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Access may occasionally be affected by maintenance, technical problems, security incidents, third-party service interruptions or circumstances outside TopCoin UK's reasonable control.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK will take reasonable steps to restore affected services where appropriate.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">21. Reporting a Problem</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers who believe there is an error or unauthorised activity involving their TopCoin Wallet, TopCoin, Captain TC Rewards Card, Captain TC Rewards Wallet, Captain TC Rewards TopCoin, Captain TC Gold Cards, Captain TC Gold Wallet or reward records should contact TopCoin UK as soon as reasonably practicable.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may request information reasonably necessary to investigate and verify the issue.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">22. Relationship With Other TopCoin UK Policies</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  This policy explains TopCoin UK's general approach to protecting its platform and loyalty programme records.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  It should be read alongside the applicable:
                </p>
                <ul className="info_description text-dark opacity-50 mb-2">
                  <li><strong>TopCoin UK General Terms & Conditions</strong></li>
                  <li><strong>Captain TC Rewards Programme Terms & Conditions</strong></li>
                  <li><strong>TopCoin UK Privacy Policy</strong></li>
                  <li><strong>TopCoin UK Cookie Policy</strong></li>
                  <li><strong>TopCoin UK Website Disclaimer</strong></li>
                  <li><strong>TopCoin UK Global Operating Policy</strong></li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  Specific eligibility, TopCoin allocation, reward entitlement, cancellation, refund and programme rules are governed by the applicable Terms & Conditions.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">23. Changes to This Policy</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may update this policy as its platform, technology, security arrangements or rewards programmes develop.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The latest version will be published with its effective or updated date.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where required, material changes affecting customers will be communicated in accordance with applicable law and the relevant TopCoin UK terms.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">24. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  For questions or concerns regarding TopCoin records, Captain TC records, account security or this policy, contact:
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-0 text-center fw-bold mt-4">
                  TopCoin UK - Transparency | Trust | Loyalty Rewards
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopCoinProtectionPolicyContent;
